export class FilterRecapture {
    constructor(
        public Year: number,
        public Factory?: string[],
        public ReleaseYear?: number,
        public Expedition?: string[]
    ) {

    }
}